import { createI18n } from 'vue-i18n'
const i18n = createI18n({
  locale: 'en',
  messages: {
    'en': {
    },
    'ar': {
      'This link is invalid please check the correct link in your email':"هذا الرابط غير صالح يرجى التحقق من الرابط الصحيح في بريدك الإلكتروني",
      'First Name':"الاسم الأول",
      'Last Name':"الاسم الأخير",
      'Phone Number':"رقم الهاتف",
      'Email':"البريد الإلكتروني",
      'Nationality':"الجنسية",
      'Country of Residence':"بلد الإقامة",
      'Identification Type':"نوع الهوية",
      'Identification Number':"رقم التعريف",
      'Passport Type':"نوع جواز السفر",
      'Passport Expiry Date':"تاريخ انتهاء صلاحية جواز السفر",
      'Date of Birth':"تاريخ الميلاد",
      'Country of Birth':"مكان الميلاد",
      'Legal Document':"الوثيقة القانونية",
      'Personal Photo':"الصورة الشخصية",
      'Job Title':"المسمى الوظيفي",
      'Address':"العنوان",
      'X URL':"رابط أكس",
      'Facebook URL':"رابط فيسبوك",
      'Place of Job':"مكان العمل",
      'Education Qualification':"المؤهل التعليمي",
      'Supported files: .png - .jpg - .jpeg - .pdf':"الملفات المدعومة: .png - .jpg - .jepg - .pdf",
      'Supported files: .png - .jpg - .jpeg':"الملفات المدعومة: .png - .jpg - .jepg",
      'File is too large, max size is 5MB':"الملف كبير جدًا، الحجم الأقصى هو 5 ميجا بايت",
      'First name is required':"الرجاء إدخال الاسم الأول",
      'Last name is required':"الرجاء إدخال الاسم الأخير",
      'Phone is required':"الرجاء إدخال الهاتف",
      'Nationality is required':"الرجاء إدخال الجنسية",
      'Country of Residence is required':"الرجاء إدخال بلد الإقامة",
      'Identification Type is required':"الرجاء إدخال نوع الهوية",
      'Identification Number is required':"الرجاء إدخال رقم الهوية",
      'Legal Document is required':"الرجاء إدخال الوثيقة القانونية",
      'Personal Photo is required':"الرجاء إدخال الصورة الشخصية",
      'Passport Type is required':"الرجاء إدخال نوع جواز السفر",
      'Passport Expiry Date is required':"الرجاء إدخال تاريخ انتهاء صلاحية جواز السفر",
      'Date of Birth is required':"الرجاء إدخال تاريخ الميلاد",
      'Country of Birth is required':"الرجاء إدخال مكان الميلاد",
      'Job Title is required':"الرجاء إدخال المسمى الوظيفي",
      'Address is required':"الرجاء إدخال العنوان",
      'X is required':"الرجاء إدخال أكس",
      'Facebook is required':"الرجاء إدخال فيسبوك",
      'Place of Job is required':"الرجاء إدخال مكان العمل",
      'Education Qualification is required':"الرجاء إدخال المؤهل التعليمي",
      'Gender is required':"الرجاء إدخال الجنس",
      'Attend is required':"الرجاء إدخال الحضور",
      'Invalid phone number':"الرجاء إدخال رقم هاتف صحيح",
      'Do you need visa?':"هل تحتاج إلى تأشيرة؟",
      'Failed to get data, please try again later':"فشل الحصول على المعلومات، الرجاء المحاولة مرة أخرى",
      'Upload legal document *png *jpg *jpeg *pdf':"تحميل الوثيقة التعريفية *png *jpg *jpeg *pdf",
      'Upload personal photo *png *jpg *jpeg':"تحميل صورة شخصية *png *jpg *jpeg",
      'Gender':"الجنس",
      'Please enter a valid KSA ID number':"الرجاء إدخال رقم هوية صحيح",
      'Please enter a valid passsport number':"الرجاء إدخال رقم جواز سفر صحيح",
      'This field is required':"هذا الحقل إجباري",
      'Click to preview PDF File':"أنقر لعرض ملف PDF",
      'Religion':"الديانة",
      'Passport Number':"رقم جواز السفر",
      'Passport Number is require':"الرجاء إدخال رقم جواز السفر",
      'Passport Issuance Country':"بلد إصدار جواز السفر",
      'Passport Issuance Date':"تاريخ إصدار جواز السفر",
      'Passport Photo':"صورة جواز السفر",
      'Upload Passport photo *png *jpg *jpeg':"تحميل صورة جواز السفر *png *jpg *jpeg *pdf",
      'Full Name is required':"الرجاء إدخال الإسم الكامل",
      'Religion is required':"الرجاء إختيار الديانة",
      'Passport Photo is required':"الرجاء تحميل صورة جواز السفر",
      'Do you have any known medical conditions or chronic illnesses?':"هل لديك أي حالات طبية معروفة أو أمراض مزمنة؟",
      'Are you currently taking any medications?':"هل تتناول أي أدوية حالياً؟",
      'Do you have any allergies?':"هل لديك أي حساسية؟",
      'Sorry, you already said that you have visa':"عذرا لقد قلت بالفعل أن لديك تأشيرة",
      "Sorry, your country doesn't required visa":"عذرا، بلدك لا يحتاج إلى تأشيرة",
      'Visa registered successfully':"تم تسجيل التأشيرة بنجاح",
      'Failed to register visa, please try again later':"فشل في تسجيل التأشيرة، يرجى المحاولة مرة أخرى لاحقًا",
      'Alternative Email':"البريد الإلكتروني البديل",
      'Alternative Email is required':"الرجاء إدخال البريد الإلكتروني البديل",
      'Please enter valid email':"الرجاء إدخال بريد إلكتروني صحيح",
      'Do you have a companion?':"هل لديك مرافق؟",
      'Do you have any allergies or medical conditions we should know about? If yes Specify?':"هل لديك أي حساسية أو حالات طبية يجب علينا معرفتها؟ إذا كانت الإجابة نعم، فالرجاء التحديد؟",
      'Are you interested in participating in media activities, such as interviews, social media features, or website content?':"هل أنت مهتم بالمشاركة في الأنشطة الإعلامية، مثل المقابلات، أو ميزات وسائل التواصل الاجتماعي، أو محتوى الموقع الإلكتروني؟",
      'Specify':"حدد",
      'Are you interested in participating in AlUla Side Tour on 17 February 2025?':"هل أنت مهتم بالمشاركة في الجولة الجانبية للعلا في 17 فبراير 2025؟",
      "(Discover the breathtaking beauty and rich heritage of AlUla through an exclusive guided tour. This once-in-a-lifetime experience takes guests on a journey through the ancient wonders, iconic landmarks, and stunning natural landscapes of Saudi Arabia's first UNESCO World Heritage Site.)":"(اكتشف الجمال الأخاذ والتراث الغني لمدينة العلا من خلال جولة إرشادية حصرية. تأخذ هذه التجربة الفريدة الضيوف في رحلة عبر العجائب القديمة والمعالم الأيقونية والمناظر الطبيعية الخلابة لأول موقع للتراث العالمي لليونسكو في المملكة العربية السعودية.",
      "We will contact you with further information about the tour.":"سنتواصل معك للحصول على مزيد من المعلومات حول الجولة.",
      'Do you require support with booking your flight to AlUla?':"هل تحتاج إلى الدعم في حجز رحلتك إلى العلا؟",
      'Do you require assistance with booking your accommodation to Alula?':"هل تحتاج إلى الدعم في حجز مكان إقامتك في العلا؟",
      'Companion First Name':"الاسم الأول للمرافق",
      'Companion Last Name':"الاسم الثاني للمرافق",
      'Companion Phone Number':"رقم الهاتف المرافق",

      'Companion First name is required':"الرجاء إدخال الاسم الأول للمرافق",
      'Companion Last name is required':"الرجاء إدخال الاسم الثاني للمرافق",
      'Companion Email':"البريد الإلكتروني للمرافق",
      'Companion Email is required':"الرجاء إدخال البريد الإلكتروني للمرافق",
      'Companion phone is required':"الرجاء إدخال رقم هاتف المرافق",
      'Yes':"نعم",
      'No':"كلا",
      'This email is already registered':"هذا البريد الإلكتروني مسجل مسبقاً",
      'The companion email is already registered':"البريد الإلكتروني الخاص للمرافق مسجل مسبقاً",
      'Personal Information':"المعلومات الشخصية",
      'Register Now':"سجل الآن",
      'Next':"التالي",
      'Submit':"تسجيل",
      'Back':"العودة للخلف",
      'Thank you for submitting your registration request for AlUla Conference for Emerging Market Economies. An email has been sent to your registered email address with further instructions to complete your registration. Please also check your junk or spam folder if you do not see the email in your inbox.':"",
      'organized by':"منظم من قبل",
      'Do you require a visa to the Kingdom of Saudi Arabia?':"هل تحتاج إلى تأشيرة دخول إلى المملكة العربية السعودية؟",
      'All Rights reserved':"جميع الحقوق محفوظة",
      'Professional Information':"معلومات مهنية",
      'Social Media':"وسائل التواصل الاجتماعي",
      'ID Number':"رقم الهوية",
      'Passport Number':"رقم جواز السفر",
      'Identification Details':"معلومات التعريف",
      'Additional Information':"معلومات إضافية",
      'Organization':"المنظمة",
      'Organization is required':"الرجاء إدخال المنظمة",
      'Companion Position is required':"الرجاء إدخال منصب المرافق",
      'Are you interested in participating in AlUla Side Tour on the 16th and 17th  February 2025?':"هل أنت مهتم بالمشاركة في الجولة الجانبية للعلا يومي 16 و 17 فبراير 2025؟",
      'ALULA \n CONFERENCE':"مؤتمر \n العلا",
      'For Emerging Market':"للأسواق الناشئة",
      'Economies':"الاقتصادات",
      'AlUla Conference For Emerging Market Economies':"مؤتمر العلا للأسواق الناشئة والاقتصادات",
      'Submit Visa':"تعبئة التأشيرة",






      'You already registerd before':"",
      'Add Companion':"",
      'Companion':"",
      'Companion Information':"",
      'It is recommended to use an email provider such as Gmail or Yahoo as info in alternative email.':"",
      'Please note that one companion only is allowed; more will be subject to availability.':"",
      'Upload Identification Document':"",
      'Education Level':"",
      'Do you require assistance with booking your flight to AlUla?':"",
      'Linkedin Url':"",
      'Father name is required':"",
      'Grandfather name is required':"",
      'Expected Arriving Date is required':"",
      "Father's Name":"",
      "Grandfather's Name":"",
      'Expected Arriving Date':"",
      'Occupation':"",
      'Occupation is required':"",
      'Event Name':"",
      'Event name is required':"",
      'Upload Personal Photo':"",
      'Upload Passport Photo':"",
      'Family Name':"",
      'Family Name is required':"",
      'Mobile Number':"",
      'Mobile Number is required':"",
      'Invalid  Mobile Number':"",
      'Mobile Number':"",
      'Country of Issuance of Passport':"",
      'Country of Issuance of Passport is required':"",
      'Passport Issue Date':"",
      'Passport Issue Date is required':"",
      'Please enter a valid date min 2025-03-01':"",
      'Please enter a valid date max 2025-01-10':"",
      'Please enter a valid date max 2020-01-01':"",
      'Please enter a valid date min 2025-01-20':"",
      'Some fields are empty or has invalid data':"",
      'ALULA':"",
      'Conference of Emerging':"",
      'Market Economies':"",
      'Search Country':"",
      'Profile':"",
      'Status':"",
      'Visa Form':"",
      'Hotel':"",
      'Basic Registration':"",
      'Basic Information':"",
      'Flight':"",
      'Female':"",
      'Male':"",
      'Aviation':"",
      'Complete':"",
      'Completed':"",
      'Aviation Support':"",
      'Did you book your flight to one of these destinations?':"",
      '(please select one of the arrival cities to assist you with connecting flight)':"",
      'Select Arrival Destination':"",
      'AlUla':"",
      'Riyadh':"",
      'Jeddah':"",
      'Dubai':"",
      'I need assistance to book my flight.':"",
      'Flight Number':"",
      'Flight From':"",
      'Flight To':"",
      'Kindly attach your itinerary below':"",
      'Request Travel Assistance':"",
      'Please book your flights for 15th february to 18th february. For assistance, click the button below to contact our travel agency.':"",
      'Flight number is required':"",
      'Destination is required':"",
      'Flight from is required':"",
      'Flight to is required':"",
      'Arrival date time name is required':"",
      'Ticket image to is required':"",
      'Book Aviation Success':"",
      'Failed to book aviation, please try again later':"",
      'Ticket uploaded successfull':"",
      'Failed to upload ticket, please try again later':"",
      'Upload Flight Itinerary (*required field)':"",
      'To complete the logistics process and finalize your arrangements, we kindly request you to upload your flight itinerary. This is essential for coordinating transportation and ensuring a seamless experience during the event.':"",
      '*Accepted file formats: pdf, jpg, or png. \n *Ensure that your itinerary includes your flight details, including dates, times, and destinations.':"",
      'If you have any questions or need assistance, please contact us at info@alulaemde.info.':"",
      'I am a resident of this city?':"",
      'Accommodation Support':"",
      'Please review the available options below and select your preferred hotel and room type for your 3-night stay during the event.':"",
      'Booked Flight Number':"",
      '*Please ensure your complete flight itinerary is submitted by 31st January to guarantee logistics support in finding connecting flights and on ground support; failure to do so may result in us being unable to provide assistance.':"",
      'The rate is applicable for a 3-night stay from february 15 to february 18, 2025.':"",
      'Transportation from the airport to the hotel and hotel to the airport is included, along with daily transportation from the selected hotels to the conference venue and back.':"",
      'Do you require assistance in booking accommodation?':"",
      '* If you are currently residing in Riyadh or Jeddah and require assistance with booking a flight to AlUla, please select “I reside in Riyadh” or “I reside in Jeddah.”':"",
      'I reside in Riyadh?':"",
      'I reside in Jeddah?':"",
      'Upon arrival in Riyadh or Jeddah, a representative holding a board with the Conference Logo will greet you and provide assistance based on the following arrangements:':"",
      'Waiting time of less than 3 hours: You will be escorted directly to the private aviation terminal for your connecting flight to AlUla.':"",
      'Waiting time exceeding 3 hours but up to 8 hours: Transportation will be arranged to a nearby lounge, where you can relax until your private flight is ready for boarding. You will then be escorted to the private aviation terminal.':"",
      'Waiting time exceeding 8 hours: A dedicated room will be reserved for you at a nearby airport hotel. Transportation will be provided from the airport to the hotel and from the hotel to the private aviation terminal to ensure a smooth boarding process for your flight to AlUla.':"",
      'Thank you for providing your travel details. Kindly attach your itinerary below.':"",
      'We will contact you with further information and assistance in finding connecting flights to AlUla':"",
      'To ensure a seamless travel experience, we kindly request adherence to the following arrival and departure schedules: ':"",
      'Arrival Schedules':"",
      'If you are unable to find a direct flight to AlUla, please plan your arrival to Riyadh or Jeddah as per the timings below to ensure smooth connecting flights:':"",
      'Arrival in Riyadh: February 15, 2025, at or before 2:00 PM (Local Time).':"",
      'Departure Schedules':"",
      'For your return journey, please schedule your departure from Riyadh or Jeddah as per the following timings to guarantee smooth connections to your final destination:':"",
      'Departure from Riyadh: February 18, 2025, at or after 2:00 PM (Local Time).':"",
      'Departure from Jeddah: February 18, 2025, at or after 5:00 PM (Local Time).':"",
      'Submission of Flight Itineraries':"",
      'To coordinate aviation and ground support effectively, please upload your flight itinerary via the registration portal no later than January 31, 2025, in line with the schedules outlined above.':"",
      '':"",
      '':"",
      '':"",
      '':"",
      '':"",
      '':"",
      '':"",
      '':"",
      '':"",
      '':"",



       




    },
  },
})
export default i18n
